import { COMMITMENT_PREPAID } from '@/modules/Contract/constants'
import {
    Contract,
    ProductResponse,
    ServiceConfigOption,
} from '@/modules/Contract/types'
import { Path, useFormContext, useWatch } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { GridHookForm } from 'vnetwork-ui'
import ServiceTimes from '../../Base/ServiceTimes'
import Configuration from './Configuration'

interface VBMProps {
    index: number
    isPOC?: boolean
    product: ProductResponse
}

const VBM: React.FC<VBMProps> = ({ index, product, isPOC = false }) => {
    const formControl = useFormContext<Contract>()
    const { t } = useTranslation()

    const service_configoptions = useWatch({
        control: formControl.control,
        name: `order.products.[${index}].service_configoptions` as Path<Contract>,
    }) as ServiceConfigOption[]

    return (
        <div>
            <GridHookForm
                subForm
                actions={[]}
                data={[
                    {
                        renderEditComponent: () => {
                            return (
                                <div data-tour="server-config">
                                    <Configuration
                                        product_config_options={
                                            product.product_config_options
                                        }
                                        index={index}
                                        isPOC={isPOC}
                                    />
                                </div>
                            )
                        },
                        className: 'col-span-4',
                    },
                    {
                        formItemProps: {
                            name: `order.products.[${index}].prepaid` as Path<Contract>,
                            type: 'select',
                            // @ts-ignore
                            options: COMMITMENT_PREPAID(t),
                            label: t('commitment_prepaid'),
                            placeholder: t('commitment_prepaid'),
                            allowClear: false,
                            onChangeAfterHookForm: (value) => {
                                const options = service_configoptions?.map(
                                    (option) => ({
                                        ...option,
                                        commitment_prepaid: value,
                                    })
                                )

                                formControl.setValue(
                                    `order.products.[${index}].service_configoptions` as Path<Contract>,
                                    options
                                )
                            },
                        },
                        className: isPOC ? 'hidden' : 'col-span-2',
                    },
                    {
                        formItemProps: {
                            name: `order.products.[${index}].service_price_register` as Path<Contract>,
                            type: 'number',
                            label: t('service_price_register'),
                            placeholder: t('service_price_register'),
                        },
                        className: isPOC ? 'hidden' : 'col-span-2',
                    },
                ]}
                formControl={formControl}
            />

            {!isPOC && <ServiceTimes index={index} disabledStatement />}
        </div>
    )
}

export default VBM
